import { render, staticRenderFns } from "./certificateInfo.vue?vue&type=template&id=213b06c1&scoped=true&"
import script from "./certificateInfo.vue?vue&type=script&lang=js&"
export * from "./certificateInfo.vue?vue&type=script&lang=js&"
import style0 from "./certificateInfo.vue?vue&type=style&index=0&id=213b06c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b06c1",
  null
  
)

export default component.exports